import { render, staticRenderFns } from "./JudgeSubmission.vue?vue&type=template&id=30b77261&"
import script from "./JudgeSubmission.vue?vue&type=script&lang=js&"
export * from "./JudgeSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports